import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The Google Sheets connector can link your spreadsheets in to PostHog to be queryable.`}</p>
    <h2 {...{
      "id": "syncing-a-worksheet"
    }}>{`Syncing a worksheet`}</h2>
    <p>{`Each Google Sheets source in PostHog is a single spreadsheet where each worksheet is represented as a schema.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Changing the name of a worksheet will require you to setup the schema in PostHog again to continue syncing it. We recommend not renaming worksheets.`}</p>
    </blockquote>
    <p>{`The first row of the spreadsheet is treated as the column names for the table. `}</p>
    <h3 {...{
      "id": "configure-google-sheets"
    }}>{`Configure Google Sheets`}</h3>
    <p>{`To connect to your Google Sheet, PostHog uses a Google Cloud service account. Thus, you must grant this service account access to your Google Sheet by following these steps:`}</p>
    <ol>
      <li parentName="ol">{`Open your Google Sheet.`}</li>
      <li parentName="ol">{`Navigate to `}<strong parentName="li">{`Share`}</strong>{`.`}</li>
      <li parentName="ol">{`Share the sheet with our service account by entering `}<inlineCode parentName="li">{`google-sheets@posthog-external.iam.gserviceaccount.com`}</inlineCode>{` into the `}<strong parentName="li">{`Add people`}</strong>{` field. We only require "Viewer" permissions to sync the sheet.`}</li>
    </ol>
    <h3 {...{
      "id": "configuring-posthog"
    }}>{`Configuring PostHog`}</h3>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Go to the `}<a parentName="p" {...{
            "href": "https://us.posthog.com/pipeline/sources"
          }}>{`sources tab`}</a>{` of the data pipeline section in PostHog.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<strong parentName="p">{`+ New source`}</strong>{` and then click `}<strong parentName="p">{`Link`}</strong>{` next to Google Sheets.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Enter the `}<strong parentName="p">{`Google Sheets URL`}</strong>{` of the sheet you want to sync and hit `}<strong parentName="p">{`Next`}</strong>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`On the next page, set up the worksheets you want to sync and modify the method and frequency as needed. Once done, click `}<strong parentName="p">{`Import`}</strong>{`. `}</p>
      </li>
    </ol>
    <p>{`Once the syncs are complete, you can start using Google Sheets data in PostHog.`}</p>
    <h2 {...{
      "id": "incremental-and-append-only-syncs"
    }}>{`Incremental and append only syncs`}</h2>
    <p>{`To enable incremental or append only syncs of your spreadsheet, we require a numerical `}<inlineCode parentName="p">{`id`}</inlineCode>{` column with auto-incrementing values. This can be achieved by using the formula `}<inlineCode parentName="p">{`=ROW()`}</inlineCode>{` in a column with the column header (row 1) being set to `}<inlineCode parentName="p">{`id`}</inlineCode>{`. This will then sync only newly added rows to PostHog`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      